/* ------------------------------------------------------------------------ */
/*		File: cmpCard_310.tsx                                               */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { ICard } from "./cmpCard_310.d";
import { getImage } from "../../components/GenericComponents/functions";
import "./cmpCard_310.css";


/* ------------------------------------------------------------------------ */

const Stars: React.FC<{total: number | undefined}> = ({total}) => {

    const iStars = Math.trunc(total!) || 0;
    const dStars = total! - iStars || 0;
    let aStars = [0, 0, 0, 0, 0];

    for (let i = 0; i < iStars; i++) { aStars[i] = 1 }
    aStars[iStars] = dStars;
    return (
        <div className="card_310_stars">
            {aStars.map((item, index) => (
                <div key={`starx-${index}`}>
                    {item === 1 ? (
                        <img key={`star-${index}`} src={getImage("star.svg")} alt={index.toString()} />
                    ) : (
                        <>
                            {item === 0.5 ? (
                                <img key={`star-${index}`} src={getImage("star-half.svg")} alt={index.toString()} />
                            ) : (
                                <img key={`star-${index}`} src={getImage("star-regular.svg")} alt={index.toString()} />
                            )}
                        </>                        
                    )}
                </div>
            ))}
        </div>
    )
}




/* ------------------------------------------------------------------------ */

const Card_310: React.FC<ICard> = ({card}: ICard) => {

    const getAcronym = (name: string) => {
       return name.split(' ').map(word => word.charAt(0)).join('')    
    }
    const randomColor = () => { return Math.floor(Math.random() * 10)

    }

    return (
        <div className="card_310">
            <div className="card_310_image">
                {card.src === null ? (
                    <div className={`card_avatar color_${randomColor()}`}>{getAcronym(card.label)}</div>
                ) : (
                    <img className="card_310_image" src={getImage(card.src)}  alt={card.src} />
                )}
            </div>
            <Stars total={card.stars} />
            <div className="card_310_description">{card.description}</div>
            <div className="card_310_label">{card.label}</div>
        </div>
    ); 
  };
  export default Card_310;